import React from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/MasterData/RemarkOption/add';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v3_add_remark_option } from '../../../actions/v3/masterData';

const AddRemarkOption = (props) => {
    const onSubmit = (model) => {
        v3_add_remark_option(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listRemarkOptionMasterData.url);
            } else {
                toast.error(res.error?.message || res.error);
            }
        });
    };

    return (
        <Layout title="Add Remark Option">
            <Form onSubmit={onSubmit} />
        </Layout>
    );
};

export default AddRemarkOption;
